import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_admin/campaigns/$campaignId')({
  component: ApplicationDetail,
});

function ApplicationDetail() {
  const { campaignId } = Route.useParams();
  return <div>Campaign {campaignId}</div>;
}
